import React from 'react';
import { Loader2 } from 'lucide-react';

const InfiniteScrollLoader = ({ hasMore, loading }) => {
    if (loading) {
        return (
            <div className="flex items-center justify-center py-8">
                <div className="flex items-center space-x-3">
                    <Loader2 className="w-6 h-6 text-blue-600 animate-spin" />
                </div>
            </div>
        );
    }

    return null;
};

export default InfiniteScrollLoader;